import { env } from "./env";
import type { Locale } from "./i18n/config";

// A docs heading takes its anchor from its own text, so that anchor differs per locale.
type Anchor = string | Readonly<Record<Locale, string>>;

// Every docs section the platform links to.
const DOCS_LINKS = {
	home: { path: "/" },
	gettingStarted: { path: "/getting-started" },
	connectClient: {
		path: "/getting-started",
		anchor: { en: "connect-an-mcp-client", sv: "anslut-en-mcp-klient" },
	},
	mcp: { path: "/mcp", anchor: "quickstart" },
	webhooks: { path: "/v1", anchor: "webhooks" },
	limits: { path: "/", anchor: { en: "limits-billing", sv: "granser-fakturering" } },
} as const satisfies Record<string, { path: string; anchor?: Anchor }>;

export type DocsLink = keyof typeof DOCS_LINKS;

// The docs pick their language from `lang` first, so a localized anchor lands on its section.
function docsUrl(path: string, { anchor, locale }: { anchor?: string; locale?: Locale }): string {
	const url = new URL(path.replace(/^\/+/, ""), `${env.DOCS_BASE_URL.replace(/\/+$/, "")}/`);
	if (locale) url.searchParams.set("lang", locale);
	if (anchor) url.hash = anchor;
	return url.toString();
}

export function docsLink(link: DocsLink, locale: Locale): string {
	const { path, anchor }: { path: string; anchor?: Anchor } = DOCS_LINKS[link];
	return docsUrl(path, { anchor: typeof anchor === "object" ? anchor[locale] : anchor, locale });
}
